module.exports = __webpack_public_path__ + "img/4.1.3be2adb8.jpg";